'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var EMPTINESS_SIGN = exports.EMPTINESS_SIGN = '—';

var isFinite = Number.isFinite;


var handleEmpty = function handleEmpty(value) {
  return isFinite(value) || value ? value : EMPTINESS_SIGN;
};

exports.default = handleEmpty;


//////////////////
// WEBPACK FOOTER
// ./~/rp-react-table/lib/RpTable/helpers/handleEmpty.js
// module id = 933
// module chunks = 0